import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

import { getWithExpiry } from '@util/LocalStorage'

const ProtectedRoute: React.FC = () => {
    const token = getWithExpiry('token')
    return token ? <Outlet /> : <Navigate to="/login" />
}

export default ProtectedRoute
